<template lang="pug">
  .container.grid-xl
    page-title(
      title="Descontos do plano"
      icon="fas fa-funnel-dollar"
      subtitle="Descontos para usuários de afiliados"
    )
      router-link.btn.btn-sm.btn-primary(
        slot="actions"
        v-if="!loading && info && info.rows.length"
        :to="{name: 'plans.discountIntegrations.create'}"
      )
        i.fas.fa-plus
        |  Adicionar desconto
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    div(v-else-if="info && !error")
      div
        .h5 {{ info.plan.title }}
        div Valor do plano sem desconto: #[b {{ info.plan.price | currency('R$') }}]
        .divider
      .flex-centered.content-full-height(v-if="info.rows.length === 0")
        empty-list.max-400(icon-class="fas fa-funnel-dollar fa-3x" title="Nenhum desconto" subtitle="Nenhum desconto para usuários de afiliados está disponível para este plano")
          .empty-action
            router-link.btn.btn-primary(:to="{name: 'plans.discountIntegrations.create'}")
              i.fas.fa-plus
              |  Adicionar desconto
      table.table.text-small(v-else)
        thead
          tr
            th Afiliado
            th(width="100px") Ativo?
            th.text-right(width="120px") Desconto
            th.text-right(width="200px") Valor
            th.text-right(width="100px") Ações
        tbody
          tr(v-for="row in info.rows")
            td {{ row.filiation.person.fullName }}
            td {{ row.active | boolean }}
            td.text-right
              span(v-if="row.discountType === 'percent'") {{ row.discountValue | currency('', ' %') }}
              span(v-if="row.discountType === 'fixed'") {{ row.discountValue | currency('R$ ') }}
            td.text-right {{ row.valueWithDiscount | currency('R$ ') }}
            td.text-right
              router-link.btn.btn-primary.btn-sm.btn-action.tooltip.tooltip-left(
                :to="{name: 'plans.discountIntegrations.edit', params: {id: info.plan.id, integrationPlanId: row.id}}"
                data-tooltip="Editar"
              )
                i.fas.fa-edit
      router-view(:plan="info.plan" :fetchData="fetchList" :integrationPlan="editing")
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import integrationPlans from '@/services/integrationPlans'

export default {
  data() {
    return {
      info: null,
      loading: false,
      error: null,
    }
  },
  computed: {
    editing() {
      const { integrationPlanId } = this.$route.params
      if (!integrationPlanId) return null

      if (!this.info && !this.info.rows) return null
      return this.info.rows.find(({ id }) => id === Number(integrationPlanId))
    },
  },
  methods: {
    async fetchList() {
      try {
        this.loading = true
        const { data } = await integrationPlans.list(this.$route.params.id)
        this.info = data
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchList()
  },
}
</script>

<style scoped lang="stylus">
.max-400
  max-width 400px
</style>
